import React, { useEffect } from "react";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
} from "../../local_node_modules/react-simle-captcha/react-simple-captcha";
import "./Captcha.css";

function Captcha() {
  useEffect(() => {
    loadCaptchaEnginge(4);
  }, []);

  return (
    <div className="user-s-none d-flex captcha-canvas-area">
      <input
        type="text"
        id="user_captcha_input"
        name="user_captcha_input"
        placeholder="Resimdeki Metni Giriniz"
        className="captcha-input"
      />
      <LoadCanvasTemplate />
    </div>
  );
}

export default Captcha;



// WEBPACK FOOTER //
// ./src/component/Captcha/index.js